import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function AgencySummaryIcon({ className }: IconProps) {
  return (
    <svg
      width="77"
      height="79"
      viewBox="0 0 77 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_923)">
        <path
          d="M62.6416 79.0002H14.3582C11.2613 79.0002 8.75098 76.5074 8.75098 73.4322V8.10752C8.75098 5.03233 11.2613 2.53955 14.3582 2.53955H62.6651C65.7619 2.53955 68.2723 5.03233 68.2723 8.10752V73.4322C68.2723 76.5074 65.7619 79.0002 62.6651 79.0002"
          fill="#EAEDF8"
        />
        <path
          d="M62.7824 79.0001H13.889C11.0502 79.0001 8.75098 76.6704 8.75098 73.7816V73.4321H68.2488C68.2488 76.5073 65.8089 79.0001 62.7824 79.0001Z"
          fill="#00C4B3"
        />
        <path
          d="M68.2488 22.0156H8.75098V5.91743C8.75098 2.65585 11.4256 0 14.7101 0H62.2897C65.5743 0 68.2488 2.65585 68.2488 5.91743V22.0156Z"
          fill="#EAEDF8"
        />
        <path
          d="M59.8264 45.6387H38.852C38.0746 45.6387 37.4443 46.2645 37.4443 47.0365V65.7905C37.4443 66.5625 38.0746 67.1884 38.852 67.1884H59.8264C60.6039 67.1884 61.2341 66.5625 61.2341 65.7905V47.0365C61.2341 46.2645 60.6039 45.6387 59.8264 45.6387Z"
          fill="white"
        />
        <path
          d="M59.8493 44.2407H38.8515C37.303 44.2407 36.0596 45.4988 36.0596 47.0131V65.7671C36.0596 67.3047 37.303 68.5628 38.8515 68.5628H59.8493C61.3978 68.5628 62.6412 67.3047 62.6412 65.7671V47.0131C62.6412 45.4755 61.3978 44.2407 59.8493 44.2407ZM59.8493 65.7904H38.8515V47.0364H59.8493V65.7904Z"
          fill="#00416B"
        />
        <path
          d="M15.7422 78.9999V47.0365C15.7422 46.2677 16.3756 45.6387 17.1499 45.6387H27.6605C28.4348 45.6387 29.0682 46.2677 29.0682 47.0365V78.9999H15.7656H15.7422Z"
          fill="white"
        />
        <path
          d="M27.6375 44.2407H17.1503C15.6018 44.2407 14.3584 45.4755 14.3584 47.0131V78.9765H17.1503V47.0131H27.6375V78.9765H30.4294V47.0131C30.4294 45.4755 29.1859 44.2407 27.6375 44.2407Z"
          fill="#00416B"
        />
        <path
          d="M9.10299 37.9974H6.31109C2.81536 37.9974 0 35.2017 0 31.7305H15.3906C15.3906 35.1784 12.5753 37.9741 9.10299 37.9741"
          fill="#00416B"
        />
        <path
          d="M24.4936 37.9975H21.7017C18.2294 37.9975 15.3906 35.2019 15.3906 31.7539H30.7812C30.7812 35.2019 27.9659 37.9975 24.4936 37.9975Z"
          fill="#00C4B3"
        />
        <path
          d="M39.9077 37.9975H37.1158C33.6435 37.9975 30.8047 35.2019 30.8047 31.7539H46.1953C46.1953 35.2019 43.3799 37.9975 39.9077 37.9975Z"
          fill="#00416B"
        />
        <path
          d="M55.2983 37.9975H52.5064C49.0341 37.9975 46.1953 35.2019 46.1953 31.7539H61.5859C61.5859 35.2019 58.7706 37.9975 55.2983 37.9975Z"
          fill="#00C4B3"
        />
        <path
          d="M70.6889 37.9975H67.897C64.4248 37.9975 61.5859 35.2019 61.5859 31.7539H76.9766C76.9766 35.2019 74.1612 37.9975 70.6889 37.9975Z"
          fill="#00416B"
        />
        <path
          d="M68.2487 22.0156H57.0576L61.5856 31.7305H76.9997L68.2487 22.0156Z"
          fill="#00416B"
        />
        <path
          d="M19.9421 22.0156L15.3906 31.7305H30.8047L32.7755 22.0156H19.9421Z"
          fill="#00C4B3"
        />
        <path
          d="M44.2246 22.0156L46.1954 31.7305H61.586L57.0579 22.0156H44.2246Z"
          fill="#00C4B3"
        />
        <path
          d="M8.75107 22.0156L0 31.7305H15.3906L19.9421 22.0156H8.75107Z"
          fill="#00416B"
        />
        <path
          d="M32.7754 22.0156L30.8047 31.7305H46.1953L44.2246 22.0156H32.7754Z"
          fill="#00416B"
        />
        <path
          d="M62.4537 8.38672C61.5857 8.38672 60.8818 9.08563 60.8818 9.94762C60.8818 10.8096 61.5857 11.5085 62.4537 11.5085C63.3218 11.5085 64.0257 10.8096 64.0257 9.94762C64.0257 9.08563 63.3218 8.38672 62.4537 8.38672ZM62.1018 9.73794C61.9611 9.73794 61.8437 9.85443 61.8437 9.99421V10.4601V10.5067H61.5857V9.48168H61.8437V9.52827C61.8437 9.52827 62.008 9.45838 62.1018 9.45838V9.71465V9.73794ZM63.4391 9.99421V10.5067H63.1576V9.99421C63.1576 9.85443 63.0403 9.73794 62.8995 9.73794C62.7587 9.73794 62.6414 9.85443 62.6414 9.99421V10.5067H62.3834V8.89925H62.6414V9.52827C62.6414 9.52827 62.8057 9.45838 62.8995 9.45838C63.2045 9.45838 63.4391 9.69135 63.4391 9.99421Z"
          fill="#00C4B3"
        />
        <path
          d="M35.8018 10.3204C36.8575 10.3204 37.7256 11.1824 37.7256 12.254C37.7256 13.3257 36.8575 14.1644 35.8018 14.1644C34.746 14.1644 33.8545 13.3024 33.8545 12.254C33.8545 11.2057 34.7226 10.3204 35.8018 10.3204ZM35.8018 8.38672C33.6668 8.38672 31.9307 10.1107 31.9307 12.2307C31.9307 14.3507 33.6668 16.0747 35.8018 16.0747C37.9368 16.0747 39.6729 14.3507 39.6729 12.2307C39.6729 10.1107 37.9368 8.38672 35.8018 8.38672Z"
          fill="#00416B"
        />
        <path
          d="M29.2088 15.9584H27.2615L24.54 8.50342H26.6516L28.2469 13.2094L29.8423 8.50342H31.9538L29.2088 15.9584Z"
          fill="#00416B"
        />
        <path
          d="M48.9169 15.9584H46.9696L44.2246 8.50342H46.3596L47.9315 13.2094L49.5269 8.50342H51.6618L48.9169 15.9584Z"
          fill="#00416B"
        />
        <path
          d="M24.5879 12.9296V12.2307V12.1608C24.541 10.0641 22.8283 8.38672 20.7168 8.38672C18.6053 8.38672 16.8457 10.1107 16.8457 12.2307C16.8457 14.3507 18.5818 16.0747 20.7168 16.0747C21.843 16.0747 22.8753 15.5855 23.5791 14.8167L22.1949 13.4422C21.843 13.8615 21.3034 14.1178 20.7168 14.1178C19.8957 14.1178 19.1918 13.6052 18.9103 12.9063H24.5879V12.9296ZM20.7168 10.2971C21.538 10.2971 22.2183 10.7863 22.4999 11.4852H18.9103C19.1918 10.7863 19.8957 10.2971 20.6934 10.2971"
          fill="#00416B"
        />
        <path
          d="M59.4512 12.9296V12.2307V12.1608C59.4043 10.0641 57.6916 8.38672 55.5801 8.38672C53.4686 8.38672 51.709 10.1107 51.709 12.2307C51.709 14.3507 53.4451 16.0747 55.5801 16.0747C56.7062 16.0747 57.7385 15.5855 58.4424 14.8167L57.0582 13.4422C56.7062 13.8615 56.1666 14.1178 55.5801 14.1178C54.759 14.1178 54.0551 13.6052 53.7736 12.9063H59.4512V12.9296ZM55.5801 10.2971C56.4012 10.2971 57.0816 10.7863 57.3632 11.4852H53.7736C54.0551 10.7863 54.759 10.2971 55.5566 10.2971"
          fill="#00416B"
        />
        <path
          d="M42.4414 12.254V4.33301H40.4941V12.2074C40.4941 12.2074 40.4941 12.2307 40.4941 12.254C40.4941 12.2773 40.4941 12.3006 40.4941 12.3006C40.5411 14.374 42.1834 16.0281 44.248 16.098V14.1643C43.2391 14.1177 42.4414 13.279 42.4414 12.2773"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_923">
          <rect width="77" height="79" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
